import { useFormContext, Controller } from 'react-hook-form';

import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
    Chip,
    Typography,
    MenuItem
} from '@mui/material';

import { useTheme } from '@emotion/react';

const SelectComponent = ({
    name,
    label, 
    list=[],
    required=false, 
    fullWidth=true, 
    startUnit,
    endIcon,
    endIconCallback,
    helper,
    sx,
    rows=1,
    ...other
}) => {
    const theme = useTheme();

    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => (
                <Box sx={{my: {xs: 1, md: 2}}}>
                    <Typography
                        fontWeight={600}
                        fontSize={{xs: 12, md: 14, lg: 16}}
                        textAlign="left"
                        lineHeight={1.5}
                        color={theme.palette.text.primary}
                        pb={2}
                    >
                        {required ? `${label} *` : label}
                    </Typography>

                    <TextField 
                        variant="outlined" 
                        value={field.value}
                        select
                        onChange={(event) => {
                            field.onChange(event.target.value);
                        }}
                        fullWidth={fullWidth}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                backgroundColor: theme.palette.background.paper,
                                borderRadius: '8px',
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: error ? 'rgba(255, 0, 0, 1)' : theme.palette.text.primary,
                                    borderWidth: "1px",
                                    borderRadius: '8px'
                                },
                                "&.Mui-focused": {
                                    "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: theme.palette.primary.main,
                                        borderWidth: "2px",
                                        borderRadius: '8px'
                                    },
                                }
                            },
                            '& legend': { display: 'none' }, '& fieldset': { top: 0 },
                            ...sx
                        }}
                        slotProps={{
                            inputLabel: {
                                style: { 
                                    color: 'rgba(145, 158, 171, 1)'
                                }
                            },
                            formHelperText: {
                                sx: {
                                    color: error ? 'rgba(255, 0, 0, 1)' : '#637381',
                                    backgroundColor: 'transparent',
                                    width: '100%',
                                    ml: 0,
                                    pl: 1
                                }
                            },
                            input: {
                                startAdornment: (
                                    startUnit
                                    ?
                                    <InputAdornment 
                                        position="start"
                                    >
                                        <Chip 
                                            label={startUnit}
                                            sx={{
                                                backgroundColor: '#E7E7E7',
                                                color: '#3D3D3D',
                                                px: 1
                                            }}
                                        />
                                    </InputAdornment>
                                    :
                                    null
                                ),
                                endAdornment : (
                                    endIcon
                                    ?
                                    <InputAdornment position="end">
                                        <IconButton
                                            onClick={endIconCallback}
                                        >
                                            {endIcon}
                                        </IconButton>
                                    </InputAdornment>
                                    :
                                    null
                                ),
                                style: {
                                    color: theme.palette.primary.main,
                                    fontWeight: 600,
                                    fontSize: 16
                                }
                            }
                        }}
                        error={!!error}
                        helperText={
                            error
                            ?
                            error.message
                            :
                            <>
                                {
                                    helper
                                    ?
                                    helper
                                    :
                                    null
                                }
                            </>
                        }
                        multiline={rows > 1}
                        rows={rows}
                        {...other}
                    >
                        {
                            list.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))
                        }
                    </TextField>
                </Box>
            )}
        />
    );
}

export default SelectComponent;